module.exports = __webpack_public_path__ + "img/no-issues-found-static-140px.cd2ebde.png";